import React ,{useEffect} from 'react'
import { AiOutlineMenu } from 'react-icons/ai'
import { FiShoppingCart } from 'react-icons/fi'
import { BsChatLeft } from 'react-icons/bs'
import { RiNotification3Line } from 'react-icons/ri'
import { MdKeyboardArrowDown } from 'react-icons/md'
import { TooltipComponent } from '@syncfusion/ej2-react-popups'

import avatar from '../data/avatar.jpg'
import {Cart , Chat , Notification , UserProfile} from '.'
import { useStateContext } from '../contexts/ContextProvider'

const NavButton =({title , custimFunc , icon , color , dotColor}) => (

  <TooltipComponent content={title} position='BottomCenter'>

    <button type='button' onClick={custimFunc} style={{color}} className='relative text-xl rounded-full p-3 hover:bg-light-gray'>
    
      <span style={{background:dotColor}} className='absolute inline-flex rounded-full h-2 w-2 right-2 top-2 '></span>
        {icon}
      

    </button>

  </TooltipComponent>

)





const Navbar = () => {

  const {chickSize ,setActiveMenu , isClicked, SideMenuClose ,handleClick , screenSize, setScreenSize , currentColor} = useStateContext()

    useEffect(() => {

        const handleResize = () => setScreenSize (window.innerWidth)
        window.addEventListener ('resize',handleResize);
        handleResize();
        return () => window.removeEventListener ('resize',handleResize);

    },[])

    useEffect(() => {

      if(screenSize <= 900){
        setActiveMenu(false);
      }else {
        setActiveMenu(true);
      }

    },[screenSize])

    const iniwindow = () => {

      setActiveMenu((prevActiveMenu) => !prevActiveMenu)
      chickSize()
      SideMenuClose() 
    }


  return (
    <div className=' flex justify-between p-2 md:mx-6 relative z-10'> 

      <NavButton title="Menu" custimFunc={() => iniwindow()}  color={currentColor} icon={<AiOutlineMenu/>}/>


      <div  className='flex'>

       <NavButton title="Cart" custimFunc={() => handleClick('cart')}  color={currentColor} icon={<FiShoppingCart/>}/>
       <NavButton title="Chat" dotColor='#9ACD32' custimFunc={() => handleClick('chat')}  color={currentColor} icon={<BsChatLeft/>}/>
       <NavButton title="Notifications" dotColor='#ffc702' custimFunc={() => handleClick('notification')}  color={currentColor} icon={<RiNotification3Line/>}/>
       <TooltipComponent content='Profile' position='BottomCenter'>
          
          <div className='flex items-center gap-2  p-1 hover:bg-light-gray rounded-lg' onClick={() => handleClick('userProfile')}> 

            <img   className='rounded-full w-8 h-8' src={avatar} alt='avatar'/>  
            
            <p>

                <span className='text-gray-400 text-14'>Hi, </span>{''}
                <span className='text-gray-400 font-bold ml-1 text-14'>Elon</span>

            </p>
            <MdKeyboardArrowDown className='text-gray-400 text-14'/>
           </div>

       </TooltipComponent>

       {isClicked.cart && <Cart/>}
       {isClicked.chat && <Chat/>}
       {isClicked.userProfile && <UserProfile/>}
       {isClicked.notification && <Notification/>}

      </div>

    </div>
  )
}

export default Navbar